module.exports = __webpack_public_path__ + "img/circle-plus.b7078e51.svg";